import { Link } from '@inertiajs/react'
import { cn } from '@/utils/cn'
import { disabledFill, filledFill, focusRing, quietFill, softFill } from '@/components/ui/buttonStyles'

/**
 * Every weight is a solid fill. Outlined buttons read as too faint against the
 * paper surfaces, so hierarchy comes from the fill colour, not from a border.
 */
type Variant = 'filled' | 'secondary' | 'quiet'

interface ButtonProps {
  variant?: Variant
  href?: string
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  className?: string
  children?: React.ReactNode
}

const variants: Record<Variant, string> = {
  filled: filledFill,
  secondary: softFill,
  quiet: quietFill,
}

const baseClass = cn(
  'inline-block rounded-full px-8 py-3.5 text-sm font-normal tracking-wide',
  'transition-colors duration-300 cursor-pointer',
  focusRing,
  disabledFill,
)

export function Button({
  variant = 'filled',
  href,
  type = 'button',
  disabled,
  onClick,
  className,
  children,
}: ButtonProps) {
  if (href !== undefined) {
    return (
      <Link
        href={href}
        className={cn(baseClass, variants[variant], className)}
      >
        {children}
      </Link>
    )
  }

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={cn(baseClass, variants[variant], className)}
    >
      {children}
    </button>
  )
}
